import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Observable } from 'rxjs';
import { SpecialistTableComponent } from 'src/app/components/tables/specialist/specialist-table.component';
import { VisitsTableComponent } from 'src/app/components/tables/visit/visit-table.component';
import { Clinic } from 'src/app/models/clinic.model';
import { Visit } from 'src/app/models/visit.model';
import { SideBarMenuService } from 'src/app/services/sidebar-menu.service';
import { VisitService } from 'src/app/services/visit.service';

@Component({
  selector: 'app-visits',
  standalone: true,
  imports: [BreadcrumbModule, AsyncPipe, SpecialistTableComponent, VisitsTableComponent],
  templateUrl: './visits.component.html',
})
export class ClinicVisitsComponent implements OnInit {
  appName: string = localStorage.getItem('appName');
  appId: string = localStorage.getItem('appId');
  clinic: Clinic;

  visits$: Observable<Visit[]>;
  home: MenuItem;
  breadcrumbItems: MenuItem[] = [];

  private visitService = inject(VisitService);
  private sidebarMenuService = inject(SideBarMenuService);
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.clinic = this.route.snapshot.data['clinic'];
    this.home = {
      icon: 'pi pi-fw pi-mobile',
      routerLink: '/',
      command: () => this.sidebarMenuService.clearSessionStorage(),
    };
    this.breadcrumbItems = [
      { label: this.appName },
      { label: 'Clínicas', routerLink: '/clinics' },
      { label: this.clinic.name },
      { label: 'Visitas', styleClass: 'font-bold' },
    ];
    // this.specialists$ = this.clinicService.findSpecialists(this.clinic.id);
    this.visits$ = this.visitService.findVisits(this.clinic);
  }
}
